<template>
  <div>
    <div v-if="cellData.entries">
      <div v-for="(entry, index) in cellData.entries" :index="index" :key="entry">
        <div id="inner" class="cell">
          <div class="let">&nbsp;{{ getPlusSign(entry.Delta) }}{{ entry.Delta }}</div>
          <font-awesome-icon v-if="entry.Delta && entry.Delta < 0" id="elred" :icon="['fas', 'triangle']" class="le fa-rotate-180" />
          <font-awesome-icon v-else-if="entry.Delta && entry.Delta > 0" id="elgrn" :icon="['fas', 'triangle']" class="le" />
          <font-awesome-icon v-else id="elgry" :icon="['fas', 'square']" class="le" />
        </div>
      </div>
    </div>
    <div id="inner" v-if="cellData && !cellData.entries" class="cell">
      <div class="let">&nbsp;{{ getPlusSign(cellData.Diff) }}{{ cellData.Diff }}</div>
      <font-awesome-icon v-if="cellData.Diff && cellData.Diff < 0" id="elred" :icon="['fas', 'triangle']" class="le fa-rotate-180" />
      <font-awesome-icon v-else-if="cellData.Diff && cellData.Diff > 0" id="elgrn" :icon="['fas', 'triangle']" class="le" />
      <font-awesome-icon v-else id="elgry" :icon="['fas', 'square']" class="le" />
    </div>
  </div>
</template>
<script>

export default {
  props: {
    cellData: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    getPlusSign(value) {
      return (value > 0) ? '+' : '';
    }
  }
};
</script>
<style scoped>
#inner {
  display: table;
  margin: 0 auto;
}
#elred { color: #882C33; }
#elgry { color: #BFBFBF; }
#elgrn { color: #444444; }

.le, .let {
  float: left;
}

.le {
  font-size: 0.75em;
  margin-left:0.25rem;
  margin-right:0.25rem;
  margin-top:0.325rem;
  margin-bottom: 0.175rem;
}
.cell{
  align-content: center;
  height: 1rem;
}

.col{
  color: #000;
}


</style>
